import { SITE_HEADER } from 'constants/site';
import Logos from 'constants/logos';

export const getSiteHeaderSettings = path => {
  const siteHeaderSettings =
    SITE_HEADER.find(siteHeaderOption =>
      path.match(siteHeaderOption.pathPattern)
    ) || {};
  return {
    variant: siteHeaderSettings.variant,
    logo: Logos[siteHeaderSettings.logo]
  };
};

export default getSiteHeaderSettings;
